import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { CorrectScoreHeaderButtonTabs } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { TabBarItem } from '../tab-bar/tab-bar.models';
import { CorrectScoreOptionGroupToggleViewService } from './correct-score-option-group-toggle-view.service';

@Component({
    standalone: true,
    selector: 'ms-toggle-view-button',
    templateUrl: './toggle-view-button.component.html',
    styleUrls: ['./toggle-view-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class ToggleViewButtonComponent implements OnInit {
    buttonTabs: TabBarItem<string>[];
    constructor(
        public sitecore: Sitecore,
        private correctScoreOptionGroupToggleViewService: CorrectScoreOptionGroupToggleViewService,
    ) {}

    ngOnInit(): void {
        this.buttonTabs = Object.entries(this.sitecore.event)
            .filter(
                ([id]) => id === CorrectScoreHeaderButtonTabs.CorrectScoreRegularView || id === CorrectScoreHeaderButtonTabs.CorrectScoreCompactView,
            )
            .map(([id, title]) => ({ id, title, active: id === this.correctScoreOptionGroupToggleViewService.currentViewId() }));
    }

    onTabClick(event: MouseEvent, id: string) {
        this.buttonTabs = this.buttonTabs.map((item) => {
            return { ...item, active: item.id === id };
        });

        this.correctScoreOptionGroupToggleViewService.setCorrectScoreView(id);

        event.stopPropagation();
        event.preventDefault();
    }
}
